export default [
  { id: 'AF', label: 'Afghanistan', spellings: 'AF افغانستان' },
  {
    id: 'AX',
    label: 'Åland Islands',
    spellings: 'AX Aaland Aland',
    priority: 0.5,
  },
  { id: 'AL', label: 'Albania', spellings: 'AL' },
  { id: 'DZ', label: 'Algeria', spellings: 'DZ الجزائر' },
  { id: 'AS', label: 'American Samoa', spellings: 'AS', priority: 0.5 },
  { id: 'AD', label: 'Andorra', spellings: 'AD', priority: 0.5 },
  { id: 'AO', label: 'Angola', spellings: 'AO' },
  { id: 'AI', label: 'Anguilla', spellings: 'AI', priority: 0.5 },
  { id: 'AQ', label: 'Antarctica', spellings: 'AQ', priority: 0.5 },
  { id: 'AG', label: 'Antigua And Barbuda', spellings: 'AG', priority: 0.5 },
  { id: 'AR', label: 'Argentina', spellings: 'AR' },
  { id: 'AM', label: 'Armenia', spellings: 'AM Հայաստան' },
  { id: 'AW', label: 'Aruba', spellings: 'AW', priority: 0.5 },
  {
    id: 'AU',
    label: 'Australia',
    spellings: 'AU',
    vatPrefix: '',
    priority: 1.5,
  },
  {
    id: 'AT',
    label: 'Austria',
    spellings: 'AT Österreich Osterreich Oesterreich',
    vatPrefix: 'AT',
  },
  { id: 'AZ', label: 'Azerbaijan', spellings: 'AZ' },
  { id: 'BS', label: 'Bahamas', spellings: 'BS' },
  { id: 'BH', label: 'Bahrain', spellings: 'BH البحرين' },
  { id: 'BD', label: 'Bangladesh', spellings: 'BD', priority: 2 },
  { id: 'BB', label: 'Barbados', spellings: 'BB' },
  { id: 'BY', label: 'Belarus', spellings: 'BY Беларусь' },
  {
    id: 'BE',
    label: 'Belgium',
    spellings: 'BE België Belgie Belgien Belgique Vlaanderen Wallonie',
    vatPrefix: 'BE',
    priority: 1.5,
  },
  { id: 'BZ', label: 'Belize', spellings: 'BZ' },
  { id: 'BJ', label: 'Benin', spellings: 'BJ' },
  { id: 'BM', label: 'Bermuda', spellings: 'BM', priority: 0.5 },
  { id: 'BT', label: 'Bhutan', spellings: 'BT भूटान' },
  { id: 'BO', label: 'Bolivia', spellings: 'BO' },
  { id: 'BQ', label: 'Bonaire, Sint Eustatius and Saba', spellings: 'BQ' },
  {
    id: 'BA',
    label: 'Bosnia and Herzegovina',
    spellings: 'BA Босна и Херцеговина',
  },
  { id: 'BW', label: 'Botswana', spellings: 'BW' },
  { id: 'BV', label: 'Bouvet Island', spellings: 'BV' },
  { id: 'BR', label: 'Brazil', spellings: 'BR Brasil', priority: 2 },
  { id: 'IO', label: 'British Indian Ocean Territory', spellings: 'IO' },
  { id: 'BN', label: 'Brunei Darussalam', spellings: 'BN' },
  { id: 'BG', label: 'Bulgaria', spellings: 'BG България', vatPrefix: 'BG' },
  { id: 'BF', label: 'Burkina Faso', spellings: 'BF' },
  { id: 'BI', label: 'Burundi', spellings: 'BI' },
  { id: 'KH', label: 'Cambodia', spellings: 'KH កម្ពុជា' },
  { id: 'CM', label: 'Cameroon', spellings: 'CM' },
  { id: 'CA', label: 'Canada', spellings: 'CA', priority: 2 },
  { id: 'CV', label: 'Cape Verde', spellings: 'CV Cabo' },
  { id: 'KY', label: 'Cayman Islands', spellings: 'KY', priority: 0.5 },
  { id: 'CF', label: 'Central African Republic', spellings: 'CF' },
  { id: 'TD', label: 'Chad', spellings: 'TD تشاد‎ Tchad' },
  { id: 'CL', label: 'Chile', spellings: 'CL' },
  {
    id: 'CN',
    label: 'China',
    spellings: 'N Zhongguo Zhonghua Peoples Republic 中国/中华',
    priority: 3.5,
  },
  { id: 'CX', label: 'Christmas Island', spellings: 'CX', priority: 0.5 },
  {
    id: 'CC',
    label: 'Cocos (Keeling) Islands',
    spellings: 'CC',
    priority: 0.5,
  },
  { id: 'CO', label: 'Colombia', spellings: 'CO' },
  { id: 'KM', label: 'Comoros', spellings: 'KM جزر القمر' },
  { id: 'CG', label: 'Congo', spellings: 'CG' },
  {
    id: 'CD',
    label: 'Congo, the Democratic Rep. o/t',
    spellings: 'CD Congo-Brazzaville Repubilika ya Kongo',
  },
  { id: 'CK', label: 'Cook Islands', spellings: 'CK', priority: 0.5 },
  { id: 'CR', label: 'Costa Rica', spellings: 'CR' },
  { id: 'CI', label: "Côte d'Ivoire", spellings: 'CI Cote dIvoire' },
  { id: 'HR', label: 'Croatia', spellings: 'HR Hrvatska', vatPrefix: 'HR' },
  { id: 'CU', label: 'Cuba', spellings: 'CU' },
  { id: 'CW', label: 'Curaçao', spellings: 'CW Curacao' },
  {
    id: 'CY',
    label: 'Cyprus',
    spellings: 'CY Κύπρος Kýpros Kıbrıs',
    vatPrefix: 'CY',
  },
  {
    id: 'CZ',
    label: 'Czech Republic',
    spellings: 'CZ Česká Ceska',
    vatPrefix: 'CZ',
  },
  {
    id: 'DK',
    label: 'Denmark',
    spellings: 'DK Danmark',
    priority: 1.5,
    vatPrefix: 'DK',
  },
  { id: 'DJ', label: 'Djibouti', spellings: 'DJ جيبوتي‎ Jabuuti Gabuuti' },
  { id: 'DM', label: 'Dominica', spellings: 'DM Dominique', priority: 0.5 },
  { id: 'DO', label: 'Dominican Republic', spellings: 'DO' },
  { id: 'EC', label: 'Ecuador', spellings: 'EC' },
  { id: 'EG', label: 'Egypt', spellings: 'EG', priority: 1.5 },
  { id: 'SV', label: 'El Salvador', spellings: 'SV' },
  { id: 'GQ', label: 'Equatorial Guinea', spellings: 'GQ' },
  { id: 'ER', label: 'Eritrea', spellings: 'ER إرتريا ኤርትራ' },
  { id: 'EE', label: 'Estonia', spellings: 'EE Eesti', vatPrefix: 'EE' },
  { id: 'ET', label: 'Ethiopia', spellings: 'ET ኢትዮጵያ' },
  {
    id: 'FK',
    label: 'Falkland Islands (Malvinas)',
    spellings: 'FK',
    priority: 0.5,
  },
  {
    id: 'FO',
    label: 'Faroe Islands',
    spellings: 'FO Føroyar Færøerne',
    priority: 0.5,
  },
  { id: 'FJ', label: 'Fiji', spellings: 'FJ Viti फ़िजी' },
  { id: 'FI', label: 'Finland', spellings: 'FI Suomi', vatPrefix: 'FI' },
  {
    id: 'FR',
    label: 'France',
    spellings: 'FR République française',
    vatPrefix: 'FR',
    priority: 2.5,
  },
  { id: 'GF', label: 'French Guiana', spellings: 'GF' },
  { id: 'PF', label: 'French Polynesia', spellings: 'PF Polynésie française' },
  { id: 'TF', label: 'French Southern Territories', spellings: 'TF' },
  { id: 'GA', label: 'Gabon', spellings: 'GA République Gabonaise' },
  { id: 'GM', label: 'Gambia', spellings: 'GM' },
  { id: 'GE', label: 'Georgia', spellings: 'GE საქართველო' },
  {
    id: 'DE',
    label: 'Germany',
    spellings: 'DE Bundesrepublik Deutschland',
    vatPrefix: 'DE',
    priority: 3,
  },
  { id: 'GH', label: 'Ghana', spellings: 'GH' },
  { id: 'GI', label: 'Gibraltar', spellings: 'GI', priority: 0.5 },
  {
    id: 'GR',
    label: 'Greece',
    spellings: 'GR Ελλάδα',
    priority: 1.5,
    vatPrefix: 'EL',
  },
  { id: 'GL', label: 'Greenland', spellings: 'GL grønland', priority: 0.5 },
  { id: 'GD', label: 'Grenada', spellings: 'GD' },
  { id: 'GP', label: 'Guadeloupe', spellings: 'GP' },
  { id: 'GU', label: 'Guam', spellings: 'GU' },
  { id: 'GT', label: 'Guatemala', spellings: 'Gt' },
  { id: 'GG', label: 'Guernsey', spellings: 'GG', priority: 0.5 },
  { id: 'GN', label: 'Guinea', spellings: 'GN' },
  { id: 'GW', label: 'Guinea-Bissau', spellings: 'GW' },
  { id: 'GY', label: 'Guyana', spellings: 'GY' },
  { id: 'HT', label: 'Haiti', spellings: 'HT' },
  { id: 'HM', label: 'Heard Islands and McDonald Islands', spellings: 'HM' },
  {
    id: 'VA',
    label: 'Holy See (Vatican City State)',
    spellings: 'VA',
    priority: 0.5,
  },
  { id: 'HN', label: 'Honduras', spellings: 'HN' },
  { id: 'HK', label: 'Hong Kong', spellings: 'HK 香港' },
  { id: 'HU', label: 'Hungary', spellings: 'HU Magyarország', vatPrefix: 'HU' },
  { id: 'IS', label: 'Iceland', spellings: 'IS Island' },
  {
    id: 'IN',
    label: 'India',
    spellings: 'IN भारत गणराज्य Hindustan',
    priority: 3,
  },
  { id: 'ID', label: 'Indonesia', spellings: 'ID', priority: 2 },
  { id: 'IR', label: 'Iran, Islamic Republic of', spellings: 'IR ایرا' },
  { id: 'IQ', label: 'Iraq', spellings: 'IQ العر' },
  {
    id: 'IE',
    label: 'Ireland',
    spelling: 'IE Éire',
    vatPrefix: 'IE',
    priority: 1.2,
  },
  { id: 'IM', label: 'Isle of Man', spellings: 'IM', priority: 0.5 },
  { id: 'IL', label: 'Israel', spellings: 'IL إسرائيل ישראל' },
  {
    id: 'IT',
    label: 'Italy',
    spellings: 'IT Italia',
    vatPrefix: 'IT',
    priority: 2,
  },
  { id: 'JM', label: 'Jamaica', spellings: 'JM' },
  {
    id: 'JP',
    label: 'Japan',
    spellings: 'JP Nippon Nihon 日本',
    priority: 2.5,
  },
  { id: 'JE', label: 'Jersey', spellings: 'JE', priority: 0.5 },
  { id: 'JO', label: 'Jordan', spellings: 'JO الأر' },
  { id: 'KZ', label: 'Kazakhstan', spellings: 'KZ Қазақстан Казахстан' },
  { id: 'KE', label: 'Kenya', spellings: 'KE' },
  { id: 'KI', label: 'Kiribati', spellings: 'KI' },
  {
    id: 'KP',
    label: "Korea, Democratic People's Rep of",
    spellings: 'KP North Korea',
  },
  {
    id: 'KR',
    label: 'Korea, Republic of',
    spellings: 'KR South Korea',
    priority: 1.5,
  },
  { id: 'XK', label: 'Kosovo', spellings: 'XK' },
  { id: 'KW', label: 'Kuwait', spellings: 'KW الكوي' },
  { id: 'KG', label: 'Kyrgyzstan', spellings: 'KG Кыргызстан' },
  { id: 'LA', label: "Lao People's Democratic Republic", spellings: 'LA' },
  { id: 'LV', label: 'Latvia', spellings: 'LV Latvija', vatPrefix: 'LV' },
  { id: 'LB', label: 'Lebanon', spellings: 'LB لبنا' },
  { id: 'LS', label: 'Lesotho', spellings: 'LS' },
  { id: 'LR', label: 'Liberia', spellings: 'LR' },
  { id: 'LY', label: 'Libyan Arab Jamahiriya', spellings: 'LY ليبي' },
  { id: 'LI', label: 'Liechtenstein', spellings: 'LI' },
  { id: 'LT', label: 'Lithuania', spellings: 'LT Lietuva', vatPrefix: 'LT' },
  { id: 'LU', label: 'Luxembourg', spellings: 'LU', vatPrefix: 'LU' },
  { id: 'MO', label: 'Macao', spellings: 'MO' },
  { id: 'ML', label: 'Mali', spellings: 'ML' },
  { id: 'MN', label: 'Mongolia', spellings: 'MN Mongγol ulus Монгол улс' },
  {
    id: 'MK',
    label: 'Macedonia, Former Yugoslav Rep. Of',
    spellings: 'MK Македонија',
  },
  { id: 'NP', label: 'Nepal', spellings: 'NP नेपाल' },
  { id: 'MG', label: 'Madagascar', spellings: 'MG Madagasikara' },
  { id: 'MW', label: 'Malawi', spellings: 'MW' },
  { id: 'MY', label: 'Malaysia', spellings: 'MY' },
  { id: 'MV', label: 'Maldives', spellings: 'MV' },
  { id: 'MT', label: 'Malta', spellings: 'MT', vatPrefix: 'MT' },
  { id: 'MH', label: 'Marshall Islands', spellings: 'MH', priority: 0.5 },
  { id: 'MQ', label: 'Martinique', spellings: 'MQ' },
  { id: 'MR', label: 'Mauritania', spellings: 'MR' },
  { id: 'MU', label: 'Mauritius', spellings: 'MU' },
  { id: 'YT', label: 'Mayotte', spellings: 'YT' },
  { id: 'MX', label: 'Mexico', spellings: 'MX Mexicanos', priority: 1.5 },
  { id: 'FM', label: 'Micronesia, Federated States of', spellings: 'FM' },
  { id: 'MD', label: 'Moldova, Republic of', spellings: 'MD' },
  { id: 'MC', label: 'Monaco', spellings: 'MC' },
  { id: 'ME', label: 'Montenegro', spellings: 'ME' },
  { id: 'MS', label: 'Montserrat', spellings: 'MS', priority: 0.5 },
  { id: 'MA', label: 'Morocco', spellings: 'MA المغرب' },
  { id: 'MZ', label: 'Mozambique', spellings: 'MZ Moçambique' },
  { id: 'MM', label: 'Myanmar', spellings: 'MM' },
  { id: 'NC', label: 'New Caledonia', spellings: 'NC', priority: 0.5 },
  { id: 'NZ', label: 'New Zealand', spellings: 'NZ Aotearoa' },
  {
    id: 'NL',
    label: 'Netherlands',
    spellings: 'NL Holland Nederland Naldisneyland',
    vatPrefix: 'NL',
    priority: 1.5,
  },
  { id: 'NA', label: 'Namibia', spellings: 'NA Namibië' },
  { id: 'NR', label: 'Nauru', spellings: 'NR Naoero', priority: 0.5 },
  { id: 'NI', label: 'Nicaragua', spellings: 'NI' },
  { id: 'NE', label: 'Niger', spellings: 'NE Nijar' },
  {
    id: 'NG',
    label: 'Nigeria',
    spellings: 'NG Nijeriya Naíjíríà',
    priority: 1.5,
  },
  { id: 'NU', label: 'Niue', spellings: 'NU', priority: 0.5 },
  { id: 'NF', label: 'Norfolk Islands', spellings: 'NF', priority: 0.5 },
  {
    id: 'MP',
    label: 'Northern Mariana Islands',
    spellings: 'MP',
    priority: 0.5,
  },
  {
    id: 'NO',
    label: 'Norway',
    spellings: 'NO Norge Noreg',
    vatPrefix: '',
    priority: 1.5,
  },
  { id: 'OM', label: 'Oman', spellings: 'OM عما' },
  { id: 'PK', label: 'Pakistan', spellings: 'PK پاکستان', priority: 2 },
  { id: 'PW', label: 'Palau', spellings: 'PW', priority: 0.5 },
  { id: 'PS', label: 'Palestinian Territory Occupied', spellings: 'PS فلسطين' },
  { id: 'PA', label: 'Panama', spellings: 'PA' },
  { id: 'PG', label: 'Papua New Guinea', spellings: 'PG' },
  { id: 'PY', label: 'Paraguay', spellings: 'PY' },
  { id: 'PE', label: 'Peru', spellings: 'PE' },
  { id: 'PH', label: 'Philippines', spellings: 'PH Pilipinas' },
  { id: 'PN', label: 'Pitcairn', spellings: 'PN', priority: 0.5 },
  {
    id: 'PL',
    label: 'Poland',
    spellings: 'PL Polska',
    vatPrefix: 'PL',
    priority: 1.25,
  },
  {
    id: 'PT',
    label: 'Portugal',
    spellings: 'PT Portuguesa',
    vatPrefix: 'PT',
    priority: 1.5,
  },
  { id: 'PR', label: 'Puerto Rico', spellings: 'PR' },
  { id: 'QA', label: 'Qatar', spellings: 'QA قطر' },
  { id: 'RE', label: 'Réunion', spellings: 'RE Reunion' },
  {
    id: 'RO',
    label: 'Romania',
    spellings: 'RO Rumania Roumania România',
    vatPrefix: 'RO',
  },
  {
    id: 'RU',
    label: 'Russian Federation',
    spellings: 'RU Rossiya Российская Россия',
    vatPrefix: '',
    priority: 2.5,
  },
  { id: 'RW', label: 'Rwanda', spellings: 'RW' },
  {
    id: 'ES',
    label: 'Spain',
    spellings: 'ES España',
    vatPrefix: 'ES',
    priority: 2,
  },
  {
    id: 'IC',
    label: 'Spain (Canary Islands)',
    spelling:
      'IC España Islas Canarias Tenerife Fuerteventura Gran Canaria Lanzarote La Palma Gomera El Hierro',
    priority: 1,
  },
  {
    id: 'EA',
    label: 'Spain (Ceuta and Melilla)',
    spellings: 'EA España Ciudades Comunidades Autónomas',
  },
  { id: 'BL', label: 'Saint Barthélemy', spellings: 'BL St. Barthelemy' },
  { id: 'SH', label: 'Saint Helena', spellings: 'SH St.' },
  { id: 'KN', label: 'Saint Kitts and Nevis', spelling: 'KN St.' },
  { id: 'LC', label: 'Saint Lucia', spellings: 'LC St.' },
  { id: 'MF', label: 'Saint Martin (French Part)', spellings: 'MF St.' },
  { id: 'PM', label: 'Saint Pierre and Miquelon', spellings: 'PM St.' },
  { id: 'VC', label: 'Saint Vincent and the Grenadines', spellings: 'VC St.' },
  { id: 'WS', label: 'Samoa', spellings: 'WS' },
  { id: 'SM', label: 'San Marino', spellings: 'SM' },
  { id: 'ST', label: 'Sao Tome and Principe', spellings: 'ST' },
  { id: 'SA', label: 'Saudi Arabia', spellings: 'SA السعودي' },
  { id: 'SN', label: 'Senegal', spellings: 'SN Sénégal' },
  { id: 'RS', label: 'Serbia', spellings: 'RS Србија Srbija' },
  { id: 'SC', label: 'Seychelles', spellings: 'RC', priority: 0.5 },
  { id: 'SL', label: 'Sierra Leone', spellings: 'SL' },
  {
    id: 'SG',
    label: 'Singapore',
    spellings: 'SG Singapura  சிங்கப்பூர் குடியரசு 新加坡共和国',
  },
  { id: 'SX', label: 'Sint Maarten (Dutch Part)', spellings: 'SX' },
  {
    id: 'SK',
    label: 'Slovakia',
    spellings: 'SK Slovenská Slovensko',
    vatPrefix: 'SK',
  },
  {
    id: 'SI',
    label: 'Slovenia',
    spellings: 'SK Slovenská Slovensko',
    vatPrefix: 'SI',
  },
  { id: 'SB', label: 'Solomon Islands', spellings: 'SB' },
  { id: 'SO', label: 'Somalia', spellings: 'SO الصوما' },
  { id: 'ZA', label: 'South Africa', spellings: 'ZA RSA Suid-Afrika' },
  { id: 'GS', label: 'South Georgia, South Sandwich Islands', spellings: 'GS' },
  { id: 'SS', label: 'South Sudan', spellings: 'SS' },
  { id: 'LK', label: 'Sri Lanka', spellings: 'LK ශ්‍රී ලංකා இலங்கை Ceylon' },
  { id: 'SD', label: 'Sudan', spellings: 'SD السود' },
  { id: 'SR', label: 'Suriname', spellings: 'SR शर्नम् Sarnam Sranangron' },
  { id: 'SJ', label: 'Svalbard and Jan Mayen', spellings: 'SJ', priority: 0.5 },
  { id: 'SZ', label: 'Swaziland', spellings: 'SZ weSwatini Swatini Ngwane' },
  {
    id: 'SE',
    label: 'Sweden',
    spellings: 'SE Sverige',
    vatPrefix: 'SE',
    priority: 1.5,
  },
  {
    id: 'CH',
    label: 'Switzerland',
    spellings: 'CH Swiss Confederation Schweiz Suisse Svizzera Svizra',
    vatPrefix: '',
    priority: 1.5,
  },
  { id: 'SY', label: 'Syrian Arab Republic', spellings: 'SY Syria سوري' },
  { id: 'TW', label: 'Taiwan', spellings: 'TW 台灣 臺灣' },
  { id: 'TJ', label: 'Tajikistan', spellings: '' },
  { id: 'TZ', label: 'Tanzania, United Republic of', spellings: 'TZ' },
  { id: 'TH', label: 'Thailand', spellings: 'TH ประเทศไทย Prathet Thai' },
  { id: 'TL', label: 'Timor-Leste', spellings: 'TL' },
  { id: 'TG', label: 'Togo', spellings: 'TG Togolese' },
  { id: 'TK', label: 'Tokelau', spellings: 'TK', priority: 0.5 },
  { id: 'TO', label: 'Tonga', spellings: 'TO' },
  { id: 'TT', label: 'Trinidad and Tobago', spellings: 'TT' },
  { id: 'TN', label: 'Tunisia', spellings: 'TN تونس' },
  { id: 'TR', label: 'Turkey', spellings: 'TR Türkiye Turkiye' },
  { id: 'TM', label: 'Turkmenistan', spellings: 'TM Türkmenistan' },
  {
    id: 'TC',
    label: 'Turks and Caicos Islands',
    spellings: 'TC',
    priority: 0.5,
  },
  { id: 'TV', label: 'Tuvalu', spellings: 'TV', priority: 0.5 },
  {
    id: 'GB',
    label: 'United Kingdom',
    spellings: 'GB Great Britain England UK Wales Scotland Northern Ireland',
    vatPrefix: 'GB',
    priority: 2.5,
  },
  { id: 'UG', label: 'Uganda', spellings: 'UG' },
  { id: 'UA', label: 'Ukraine', spellings: 'UA Ukrayina Україна' },
  { id: 'AE', label: 'United Arab Emirates', spellings: 'AE UAE الإما' },
  {
    id: 'US',
    label: 'United States of America',
    spellings: 'US USA United States of America',
    priority: 3.5,
  },
  { id: 'UM', label: 'United States Minor Outlying Islands', spellings: 'UM' },
  { id: 'UY', label: 'Uruguay', spellings: 'UY' },
  {
    id: 'UZ',
    label: 'Uzbekistan',
    spellings: "UZ Ўзбекистон O'zbekstan O‘zbekiston",
  },
  { id: 'VU', label: 'Vanuatu', spellings: 'VU' },
  { id: 'VE', label: 'Venezuela', spellings: 'VE' },
  { id: 'VN', label: 'Vietnam', spellings: 'VN Việt Nam', priority: 1.5 },
  {
    id: 'VG',
    label: 'Virgin Islands, British',
    spellings: 'VG',
    priority: 0.5,
  },
  { id: 'VI', label: 'Virgin Islands, U.S', spellings: 'VI', priority: 0.5 },
  { id: 'WF', label: 'Wallis and Futuna', spellings: 'WF', priority: 0.5 },
  { id: 'EH', label: 'Western Sahara', spellings: 'EH لصحراء الغربي' },
  { id: 'YE', label: 'Yemen', spellings: 'YE اليم' },
  { id: 'ZM', label: 'Zambia', spellings: 'ZM' },
  { id: 'ZW', label: 'Zimbabwe', spellings: 'ZW' },
];
